export const skeleton = {
  variant: {
    variantText: "text",
    variantCircular: "circular",
    variantRectangular: "rectangular",
    variantRounded: "rounded",
  },
};
